import type { CompanyUser } from "@/apis/gql/types";
import { useSession } from "@/lib/auth/auth";

import { useMemo } from "react";

import { useCompany } from "@/src/routes/_authenticated/$company/_route";

export function useTenant() {
  const company = useCompany();

  const { data: session } = useSession();

  const userCompanyRole = useMemo(() => {
    const _user = session?.user;
    const companyUsers = company?.users;

    const userInCompany = companyUsers?.find(
      (user: CompanyUser) => user.userId === _user?.userId,
    );

    return userInCompany?.companyRole;
  }, [company, session?.user]);

  const values = useMemo(() => {
    return {
      tenantId: company?.companyId ?? "",
      companyName: company?.companyName,
      companySlug: company?.companySlug,
      isOcrReviewRequired: company?.ocrReviewRequired,
      isPaymentEnabled: company?.paymentEnabled,
      hasCostCenters: company?.hasCostCenters,
      isVorsteuerabzug: company?.vorsteuerabzug,
      invoiceInboxEnabled: company?.invoiceInboxEnabled,
      companyUsers: company?.users,
      isDiy: company?.diy,
      role: userCompanyRole,
      companyCreatedAt: company?.createdAt,
    };
  }, [company]);

  return values;
}
